export default __webpack_public_path__ + "static/icono_usuaria3-36ca10ccbb79aab3af5de16f9211f7b7.png";